import { createSelector } from '@reduxjs/toolkit';
import type { IListKey, IListViewState, ViewKey } from '@platform/core/types';
import type { IModuleSliceHandle } from '../modules/IModuleSliceHandle';
import type { RootState } from '../RootState';
import { defaultListViewState, listKeyOf } from '../slices/viewStateSlice';

/** Стан списку для пункту меню з платформного viewState (модулі без пакета) або типовий стан із представленням за замовчуванням. */
export const selectListState = (key: IListKey, defaultView: ViewKey) =>
  createSelector([(s: RootState) => s.viewState], (vs): IListViewState => vs[listKeyOf(key)] ?? defaultListViewState(defaultView));

/** Стан списку зі зрізу пакета модуля (ключ `воркспейс|тип|пункт меню`) або типовий стан із представленням за замовчуванням. */
export const selectModuleListState = (slice: IModuleSliceHandle, listKey: string, defaultView: ViewKey) =>
  createSelector([slice.selectLists], (lists): IListViewState => lists[listKey] ?? defaultListViewState(defaultView));
